import React, { Fragment, useState, useEffect, memo, useContext } from "react";
import axios from "axios";
import { variables } from "../../Variables";
import theme from "../UI/Theme";
import Deposits from "../Deposits";
import { SocketContext } from "../../utils/socket-client";
import { SyncLoader } from "react-spinners";

// MUI IMPORTS
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import Box from "@mui/material/Box";

const PaymentsOut = (props) => {
  const { tabInitialDate, tabFinalDate, myTitle, refresh } = props;

  const mySocket = useContext(SocketContext);
  const [socket, setSocket] = useState(null);

  const [paymentsByDateList, setPaymentsByDateList] = useState([]);
  const [totalPaymentsSuppByDate, setTotalPaymentsSuppByDate] = useState(0);

  const [totalPaymentsDIRByDate, setTotalPaymentsDIRByDate] = useState(0);
  const [DIRPaymentsByDateList, setDIRPaymentsByDateList] = useState([]);

  const [totalPaymentsFIXByDate, setTotalPaymentsFIXByDate] = useState(0);
  const [FIXPaymentsByDateList, setFIXPaymentsByDateList] = useState([]);

  const [totalPaymentsFIXByDate_Ops, setTotalPaymentsFIXByDate_Ops] = useState(0);
  const [totalPaymentsFIXByDate_NonOps, setTotalPaymentsFIXByDate_NonOps] = useState(0);

  const [showDetails, setShowDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [needsRefresh, setNeedsRefresh] = useState(false);

  const showDetailsHandler = () => setShowDetails((prev) => !prev);

  // --- API CALLS ---
  const fetchData = () => {
    if (!tabInitialDate || !tabFinalDate) return;

    setIsLoading(true);

    const p1 = axios.get(`${variables.API_URL}/purchase/paymentsoutbydate/${tabInitialDate}/${tabFinalDate}`, { withCredentials: true });
    const p2 = axios.get(`${variables.API_URL}/salaries/dirsalariespaidbydate/${tabInitialDate}/${tabFinalDate}/1`, { withCredentials: true });
    const p3 = axios.get(`${variables.API_URL}/salaries/fixsalariespaidbydate/${tabInitialDate}/${tabFinalDate}/1`, { withCredentials: true });

    Promise.all([p1, p2, p3])
      .then(([resSupp, resDIR, resFIX]) => {
        // Suppliers
        const dataSupp = resSupp.data.paymentsOutByDate || [];
        setPaymentsByDateList(dataSupp);
        setTotalPaymentsSuppByDate(dataSupp.length > 0 ? dataSupp.slice(-1)[0].cumulative_sum : 0);

        // DIR Salaries
        const dataDIR = resDIR.data.salariesPayByDate || [];
        setDIRPaymentsByDateList(dataDIR);
        setTotalPaymentsDIRByDate(dataDIR.length > 0 ? dataDIR.slice(-1)[0].cumulative_sum : 0);

        // FIX Salaries
        const dataFIX = resFIX.data.salariesPayByDate || [];
        setFIXPaymentsByDateList(dataFIX);
        setTotalPaymentsFIXByDate(dataFIX.length > 0 ? dataFIX.slice(-1)[0].cumulative_sum : 0);

        // Separate FIX Costs (Ops vs Non-Ops)
        if (dataFIX.length > 0) {
          const ops = dataFIX.filter(item => item.TYPECOST_ID === 1).reduce((acc, curr) => acc + curr.TOTALPAID_FIX, 0);
          const nonOps = dataFIX.filter(item => item.TYPECOST_ID === 2).reduce((acc, curr) => acc + curr.TOTALPAID_FIX, 0);
          setTotalPaymentsFIXByDate_Ops(ops);
          setTotalPaymentsFIXByDate_NonOps(nonOps);
        }

        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error in PaymentsOut:", err);
        setIsLoading(false);
      });
  };

  // --- EFECTO: Carga de datos ---
  useEffect(() => {
    fetchData();
  }, [tabInitialDate, tabFinalDate, refresh, needsRefresh]);

  // --- SOCKET LOGIC ---
  useEffect(() => {
    setSocket(mySocket);
  }, [mySocket]);

  useEffect(() => {
    if (!socket) return;
    const handleNotification = (data) => {
      const type = data.type.notificationType;
      if (type === 4 || type === 5 || type === 6) {
        setNeedsRefresh(prev => !prev);
      }
    };
    socket.on("getNotification", handleNotification);
    return () => socket.off("getNotification", handleNotification);
  }, [socket]);

  return (
    <Fragment>
      {!isLoading ? (
        <Deposits
          title={myTitle || "Payments Out"}
          totalPaymentsByDate={
            myTitle === "Salary Paid"
              ? totalPaymentsDIRByDate + totalPaymentsFIXByDate
              : myTitle === "Payments Suppliers"
              ? totalPaymentsSuppByDate
              : totalPaymentsSuppByDate + totalPaymentsDIRByDate + totalPaymentsFIXByDate
          }
          selectedDatesFromInitial={tabInitialDate}
          selectedDatesTo={tabFinalDate}
          paymentsByDateList={paymentsByDateList}
          DIRPaymentsByDateList={DIRPaymentsByDateList}
          FIXPaymentsByDateList={FIXPaymentsByDateList}
          totalPaymentsSuppByDate={totalPaymentsSuppByDate}
          totalPaymentsDIRByDate={totalPaymentsDIRByDate}
          totalPaymentsFIXByDate={totalPaymentsFIXByDate}
          totalPaymentsFIXByDate_Ops={totalPaymentsFIXByDate_Ops}
          totalPaymentsFIXByDate_NonOps={totalPaymentsFIXByDate_NonOps}
          totalPaymentsUnallocatedByDate={0}
          showDetails={showDetails}
          showDetailsHandler={showDetailsHandler}
          icon={<CreditCardOffIcon sx={{ fontSize: 20, color: "#4E1721", marginRight: 2, mt: -1 }} />}
        />
      ) : (
        <Box textAlign="center" sx={{ py: 2 }}>
          <SyncLoader color="#7A1125" size={15} />
        </Box>
      )}
    </Fragment>
  );
};

export default memo(PaymentsOut, (prev, next) => {
  return (
    prev.tabInitialDate === next.tabInitialDate &&
    prev.tabFinalDate === next.tabFinalDate &&
    prev.refresh === next.refresh &&
    prev.myTitle === next.myTitle
  );
});